export const modifyTransaction = (transaction, customerAndAccountArr) => {
    const date = new Date(transaction.timeStamp);
    const comment = transaction.comment;

    // Dynamically format the date based on window width
    let formattedDate = `${date.getDate().toString().padStart(2, "0")}.${(date.getMonth() + 1).toString().padStart(2, "0")} ${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    if (window.innerWidth > 650) {
        formattedDate = date.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: false,
            timeZone: "Asia/Dubai",
        });
    }

    const modifyPlace = (placeArr) => {
        return placeArr.map((f) => {
            const icon_id = customerAndAccountArr?.find((acc) => acc._id.toString() === f.place.accountId)?.icon;
            return {
                ...f,
                name: customerAndAccountArr.find((c) => [f.place?.customerId, f.place?.accountId].includes(c._id.toString()))?.name,
                icon: f.place?.customerId ? "/img/user.png" : icon_id ? `${process.env.REACT_APP_IMG_SRC}/api/icons/${icon_id}` : "/img/not-found.png",
            };
        });
    };
    transaction.labels.map((l) =>
        customerAndAccountArr.find((c) => {
            return c._id.toString() === l.customerId?.toString() || c._id.toString() === l.accountId?.toString();
        })
    );

    function resolveLabels(transactionLabels, customerAndAccountArr) {
        const resolved = [];

        for (const l of transactionLabels) {
            const match = customerAndAccountArr.find((c) => {
                if (typeof l === "string") {
                    if (l === `${c.name} ${c.type ? ` (${c.type})` : ""}`) {
                        return true;
                    }
                }
                if (c._id.toString() === l?.toString() || c._id.toString() === l.customerId?.toString() || c._id.toString() === l.accountId?.toString()) {
                    return true;
                }
                return false;
            });

            if (match) {
                const label = `${match.name} ${match.type ? ` (${match.type})` : ""}`;
                resolved.push(label);
            }
        }

        return resolved;
    }
    return {
        id: transaction._id || transaction.id,
        from: modifyPlace(transaction.from),
        to: modifyPlace(transaction.to),
        date: formattedDate,
        comment: comment,
        toBeBounded: transaction.toBeBounded,
        joined_transaction_id: transaction.joined_transaction_id,
        boundable: transaction.from[0].place.customerId || transaction.to[0].place.customerId,
        signature: transaction.signature,
        timeStamp: transaction.timeStamp,
        labels: resolveLabels(transaction.labels, customerAndAccountArr),
        deletable: transaction.deletable,
        finished: transaction.finished,
    };
};
